export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10554.923f2531.jpg";